import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebTrafficPage: React.FC = () => {
  const traffic = analyticsSnapshot.webAnalytics.traffic;
  const latestSessions = findLatestValue(traffic.datasets[0].data);
  const latestUsers = findLatestValue(traffic.datasets[1].data);
  const latestLabel = latestSessions.index >= 0 ? traffic.labels[latestSessions.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.webAnalytics.traffic.insights;

  const chartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(traffic.labels),
      datasets: traffic.datasets.map((dataset) => ({
        label: dataset.label === 'sessions' ? 'Oturumlar' : 'Kullanıcılar',
        data: Array.from(dataset.data)
      }))
    }),
    [traffic.labels, traffic.datasets]
  );

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Web Trafik Özeti</h1>
          <p className="text-white/70 mt-2 text-sm md:text-base">
            Ziyaretçi sayıları, oturum hacmi ve organik/ücretli arama performansı üzerinden trafik trendleri.
          </p>
        </div>
        <div className="text-xs md:text-sm text-white/40">
          Son veri: <span className="text-white/70">{latestLabel}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricSummary title="Oturumlar" value={latestSessions.value} description="Son ölçülen ay." />
        <MetricSummary title="Toplam Kullanıcı" value={latestUsers.value} description="Toplam benzersiz ziyaretçi." />
      </div>

      <ChartCard
        title="Aylık Trafik Trendleri"
        description="Oturum ve kullanıcı sayılarındaki aylık değişimi izleyin."
        data={chartData}
        chartType="line"
        insights={insights}
      />

    </div>
  );
};

export default WebTrafficPage;

